module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/features-handoff-assets.json
// module id = 1992
// module chunks = 274673045319241